import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface Section01Props extends React.HTMLAttributes<HTMLElement> {
  section: any;
}

const Section = ({ className, section, style, ...props }: Section01Props) => {
  return (
    <section
      className={twMerge(classNames("relative overflow-y-hidden", className, section?.SectionElement?.ClassName))}
      data-friendly-name={section?.FriendlyName ?? "Unknown Section"}
      data-abstract-name={section?.__component ?? "Unknown Section"}
      id={section?.SectionElement?.HtmlId}
      style={{
        ...style,
        ...section?.SectionElement?.Style,
      }}
      {...props}
      {...section?.SectionElement?.Rest}
    />
  );
};

export default Section;
